import React from "react";
import BackButton from "./BackButton";
import { Typography } from "antd";
import dayjs from "dayjs";
import useSelectedService from "hooks/useSelectedService";

const { Title } = Typography;

const h4Style = {
  marginBottom: 0,
  marginTop: 0,
  marginLeft: 12,
};
const flexBaselineStyle = {
  display: "flex",
  alignItems: "baseline",
  marginTop: 5,
};

const PageLayoutWrapper = ({ children, title, sales = false }) => {
  // const { auth } = useAuth();
  const { selectedService } = useSelectedService();

  const rightContent = [];
  //if (auth?.data) rightContent.push(auth.data.name);
  if (selectedService && sales === false) {
    rightContent.push(`${selectedService.product?.name}: ${selectedService.service_id_raw}`);
  }
  if (selectedService && sales === true) {
    const equipmentString = selectedService.equipment.map((e) => e.name).join(", ");
    rightContent.push(
      `${equipmentString} / ${selectedService.product?.name} / ${dayjs(selectedService.start_date).format("HH:mm")} / Nr. Pax Embarcadas: ${selectedService.embarked_count || 0} Pax`,
    );
  }

  return (
    <div style={{ minHeight: "100vh" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: -10 }}>
        <div style={flexBaselineStyle}>
          <BackButton />
          {title && (
            <Title level={4} style={h4Style}>
              {title}
            </Title>
          )}
        </div>
        <div style={flexBaselineStyle}>
          <Title level={sales ? 5 : 4} style={h4Style}>
            {rightContent.join(", ")}
          </Title>
        </div>
      </div>
      <div>{children}</div>
    </div>
  );
};

export default PageLayoutWrapper;
